var React = require('react');

function DollarBill (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#323643","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M2 16.615V7.607C2 6.72 2.72 6 3.607 6h16.786C21.28 6 22 6.72 22 7.607v9.008c0 .888-.72 1.607-1.607 1.607H19.33h0H3.607c-.887 0-1.607-.72-1.607-1.607z","key":0}),React.createElement("path",{"d":"M14.666 12.111c0 1.5-1.194 2.716-2.667 2.716-1.472 0-2.666-1.216-2.666-2.716 0-1.5 1.194-2.716 2.666-2.716 1.473 0 2.667 1.216 2.667 2.716zm-9.332 0h1.333m10.666 0h1.334M5.334 6c0 1.875-1.493 3.396-3.334 3.396m20 0c-1.841 0-3.334-1.52-3.334-3.396m-.059 12.126c0-1.875 1.493-3.396 3.334-3.396M2 14.827c1.841 0 3.334 1.52 3.334 3.395","key":1})]));
}

DollarBill.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = DollarBill;

DollarBill.default = DollarBill;
